<template>
    <div>
      <div id="contentbg">
          <div id="contentbg1">
              <div class="jdbg"><router-link to="/About/Introduction"><img src="../assets/ljwm_04.png" width="202" height="54" /></router-link></div>
          </div>
      </div>
      <!--业务简介--药聚多商城-->
      <div class="tonglan">
          <div class="ywjj">
              <h2>业务简介</h2>
              <h3>BUSINESS PROFILE</h3>
          </div>
          <!--药聚多商城-->
          <div class="mail">
              <div class="mailleft"></div>
              <div class="mailright">
                  <h3>药聚多商城</h3>
                  <ul>
                      <li>
                          <p style="padding-bottom:10px;">
                              药聚多商城是面向药店、诊所、医院、医药公司提供互联网药品交易服务的第三方平台。目前药聚多拥有：<br />
                          </p>
                          <p>
                              <span class="blue1"><img src="../assets/quan.png" style="width:15px;height:15px;" />&nbsp;&nbsp;</span>80,000多个医药类商品；<br />
                              <span class="blue1"><img src="../assets/quan.png" style="width:15px;height:15px;" />&nbsp;&nbsp;</span>144,000家终端用户。<br />
                          </p>
                      </li>
                  </ul>
                  <p><router-link to="/Cyz?target=register"><img src="../assets/yjdhn_09.png" width="160" height="43" /></router-link></p>
              </div>
              <div class="clear"></div>
          </div>
      </div>
      <!--区域服务经理-->
      <div id="contentbg">
          <div class="tonglan">
              <div class="manager">
                  <div class="partnerleft"></div>
                  <div class="mailright">
                      <h3>区域合作伙伴</h3>
                      <ul>
                          <li>
                              <a href="">
                                  <p style="padding-bottom:10px;">
                                      药聚多面向全国范围启动区域合作伙伴加盟计划，旨在提升当地终端客户的服务体验，提高自身产品的市场占有率。<br />
                                      服务内容：
                                  </p>
                                  <p style="padding-bottom:10px;">
                                      <span class="blue1"><img src="../assets/quan.png" style="width:15px;height:15px;" />&nbsp;&nbsp;</span>面向当地药店、诊所、医药公司推广、安装药聚多；<br />
                                      <span class="blue1"><img src="../assets/quan.png" style="width:15px;height:15px;" />&nbsp;&nbsp;</span>整合平台及自有品种库上传至云端，利用云库存，为当地终端客户提供属地化服务。<br />
                                  </p>
                              </a>
                          </li>
                      </ul>
                      <p><router-link to="/Cyz?target=register"><img src="../assets/yjdhn_16.png" width="160" height="43" /></router-link></p>
                  </div>
                  <div class="clear"></div>
              </div>
          </div>
      </div>
      <div class="tonglan">
          <div class="ywjj">
              <h2>产品下载</h2>
              <h3>PRODUCT DOWNLOAD</h3>
          </div>
          <div class="cpxzt">
              <div class="qhtu">
                  <dl :class="{'up':showBlock}" @mouseover="showBlock=true">终端会员采购系统</dl>
                  <dl :class="{'up':!showBlock}" @mouseover="showBlock=false">业务员专用采购系统</dl>
                  <div class="clear"></div>
              </div>
              <!--终端会员采购系统-->
              <ol v-show="showBlock">
                  <div class="zdhyban">
                      <div class="zdhybleft">
                          <div class="zdhybbutr"><a href="https://www.yaojuduo.com/ClientUpdate/YaoJuDuo/药聚多.rar" target="_blank"><img src="../assets/yjd_1.png" width="264" height="57" /></a></div>
                      </div>
                      <div class="zdhybright">
                          <div class="zdhybbutl"><a href="https://www.yaojuduo.com/App/YaoJuDuo.apk" target="_blank"><img src="../assets/yjd_2.png" width="264" height="57" /></a></div>
                      </div>
                      <div class="clear"></div>
                  </div>
              </ol>
              <!--业务员专用采购系统-->
              <ol v-show="!showBlock">
                  <div class="ywyban">
                      <div class="ywyleft">
                          <div class="ywybutr"><a href="https://www.yaojuduo.com/SaleApp/softupdate/医药销售管理系统.msi" target="_blank"><img src="../assets/ywy_1.png" width="264" height="57" /></a></div>
                      </div>
                      <div class="ywyright">
                          <div class="ywybutl"><a href="https://www.yaojuduo.com/app/MedicineServe.apk" target="_blank"><img src="../assets/ywy_2.png" width="264" height="57" /></a></div>
                      </div>
                      <div class="clear"></div>
                  </div>
              </ol>
          </div>
      </div>
  </div>
  </template>

<script>
export default {
  name: 'Home',
  data () {
    return {
      showBlock: true
    }
  }
}
</script>
